import PropTypes from 'prop-types';

export const editorPropTypes = PropTypes.shape({
  select: PropTypes.func,
  getLastPosition: PropTypes.func,
  insertImage: PropTypes.func,
  insertInternalLink: PropTypes.func,
  readOnly: PropTypes.bool,
  setNodeByKey: PropTypes.func,
});
